const history = {
    en: {
        history: {
            pageTitle: 'Translation History',
            pageDescription: 'Review your most recent translations. We save your last 100 translations automatically to keep things fast and clean.',
            recordsLabel: 'Records',
            emptyTitle: 'No translations yet',
            emptyDesc: 'Any translations you make will automatically appear here.',
            originalLabel: 'Original Text',
            originalWithLang: '{lang} (Original)',
            tone: 'Tone: {value}',
            formality: 'Formality: {value}%',
            confirmDeleteTitle: 'Delete Translation Record',
            confirmDeleteMessage: 'Are you sure you want to remove this translation from your history?',
            tableAria: 'Translation history table',
            col: {
                original: 'Original Text',
                translated: 'Translation',
                languages: 'Languages',
                mode: 'Mode',
                actions: 'Actions',
            },
        },
        lists: {
            noRecords: 'No records found',
            tableAria: 'Data table',
            latest: 'Latest',
            oldest: 'Oldest',
            latestFirst: 'Latest First',
            oldestFirst: 'Oldest First',
            sortOptions: 'Sort options',
            searchPlaceholder: 'Search within these records...',
        },
    },
    th: {
        history: {
            pageTitle: 'ประวัติการแปล',
            pageDescription: 'ดูการแปลล่าสุดของคุณ เราบันทึกการแปล 100 รายการล่าสุดโดยอัตโนมัติเพื่อความรวดเร็วและเป็นระเบียบ',
            recordsLabel: 'รายการ',
            emptyTitle: 'ยังไม่มีการแปล',
            emptyDesc: 'การแปลที่คุณทำจะปรากฏที่นี่โดยอัตโนมัติ',
            originalLabel: 'ข้อความต้นฉบับ',
            originalWithLang: '{lang} (ต้นฉบับ)',
            tone: 'โทน: {value}',
            formality: 'ความเป็นทางการ: {value}%',
            confirmDeleteTitle: 'ลบรายการการแปล',
            confirmDeleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบการแปลนี้ออกจากประวัติ?',
            tableAria: 'ตารางประวัติการแปล',
            col: {
                original: 'ข้อความต้นฉบับ',
                translated: 'คำแปล',
                languages: 'ภาษา',
                mode: 'โหมด',
                actions: 'จัดการ',
            },
        },
        lists: {
            noRecords: 'ไม่พบรายการ',
            tableAria: 'ตารางข้อมูล',
            latest: 'ล่าสุด',
            oldest: 'เก่าสุด',
            latestFirst: 'ล่าสุดก่อน',
            oldestFirst: 'เก่าสุดก่อน',
            sortOptions: 'ตัวเลือกการเรียงลำดับ',
            searchPlaceholder: 'ค้นหาในรายการเหล่านี้...',
        },
    },
};

export default history;
